import React from "react";

const CustomSVG = ({
  svg: SvgComponent, // SVG component passed as a prop
  width = "w-10", // Tailwind width class, default to 6rem (w-24)
  height = "h-10", // Tailwind height class, default to 6rem (h-24)
  color = "text-blue-500", // Default color class
  hoverColor = "text-green-500", // Hover color class
  additionalClasses = "", // Additional Tailwind classes for customization
  onClick = null, // onClick event handler
}) => {
  return (
    <div
      className={`inline-block ${width} ${height} ${additionalClasses} ${onClick ? "cursor-pointer" : ""} group`}
      onClick={onClick}
    >
      {SvgComponent && (
        <SvgComponent
          //   className={`w-full h-full fill-current stroke-current ${color} group-hover:${hoverColor} transition-colors duration-300`}
          className={`w-full h-full fill-current ${color} group-hover:${hoverColor} transition-colors duration-300`}
          //   fill={color}
        />
      )}
    </div>
  );
};

export default CustomSVG;
